import { computed, getCurrentInstance } from 'vue';
import signLog from '@/components/sign-log';
import util from '@/common/util';
import { getStore } from '@/store';
import useLng from '@/hooks/useLng';
import useEventBus from '@/plugins/eventBus';
import { buildUrl, getRouteOptions } from '@/router/index.js';

const noVow = computed(() => {
    const pageStore = getStore('page');
    return pageStore.pageKey === 'agent-detail'
});
const isShowMask = (isProtected) => {
    const userStore = getStore('user');
    return isProtected && !userStore.userEmailVerified && !noVow.value
};

const getVowDetailLink = (houseData, addressReplaceStr = 'address') => {
    let { link, status } = houseData;

    let routeInfo = {};
    if (status?.toLowerCase() === 'sold') {
        routeInfo = getRouteOptions({ name: 'sold-detail', url: link });
    } else {
        routeInfo = getRouteOptions({ name: 'listing-detail', url: link });
    }
    routeInfo.params.address = addressReplaceStr;
    if (routeInfo.name) {
        return buildUrl(routeInfo)
    }
    return link;
}
export function calcHouseLink(houseData) {
    let { link, isProtected, addressPartialFlag } = houseData;
    if (isShowMask(isProtected)) {
        // changed real address to 'address'
        link = getVowDetailLink(houseData);
    } else if (addressPartialFlag === 1) {
        // changed real address to 'Address-not-disclosed'
        link = getVowDetailLink(houseData, 'Address-not-disclosed');
    }
    return link;
}

export function transformLink2WordPress(link) {
    const pageStore = getStore('page');
    return util.transformLink2WordPress(
        link,
        pageStore.wordPressSSR,
        noVow.value
    );
}

export function useHouseCollect({ house, collectSuccessCallback } = {}) {
    const { proxy } = getCurrentInstance()
    const pageStore = getStore('page');
    const userStore = getStore('user');
	
    const widget = computed(() => pageStore.widget);
    const hasLoggedIn = computed(() => userStore.hasLoggedIn);

    let collectPsRes = null
    const collect = (item) => {
        const $t = useLng('md-house');
        let link = calcHouseLink(item);
        let data = {
            listingId: item.id,
            listingDetail: transformLink2WordPress(link),
            status: item.collected ? 2 : 1,
            address: item?.address,
            listingUrl: transformLink2WordPress(link)
        };
		
        if (widget.value) {
            let url = util.setQueryField(
                { fav: data.status },
                data.listingDetail,
                false
            );
            window.open(url, '_blank');
        } else {
            return new Promise(resolve => {
                collectPsRes = resolve;
                if (!hasLoggedIn.value) {
                    signLog.register({
                        languageTextFn: {
                            registerTitle: _ => $t('md-house.addHomeToFavorites'),
                            registerSubTitle: _ => $t('md-house.getAProfessionalReal')
                        },
                        onsuccess: () => {
                            doCollect(data);
                        }
                    });
                } else {
                    doCollect(data);
                }
            });
        }
    }
	
    const doCollect = (data) => {
        const eventBus = useEventBus()
        eventBus.$emit('siteTrack', {
            ...data,
            trackType: 'favor-click'
        });
        return proxy.axiosIns
            .get('/api-site/listingCollect', {
                params: Object.assign(
                    {
                        timestamp: new Date().getTime()
                    },
                    data
                )
            })
            .then(() => {
                if (collectPsRes) {
                    collectPsRes();
                    collectSuccessCallback?.(data);
                    collectPsRes = null;
                }
            });
    }
	
    return {
        collect,
    }
}